import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
function ModalBody(_ref) {
  var {
    className = 'modal-body',
    style,
    children,
    'data-testid': dataTestId
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: className,
    "data-testid": dataTestId,
    style: style,
    children: children
  });
}
export default ModalBody;
//# sourceMappingURL=ModalBody.js.map